import { API_BASE_URL } from '../services/api';
import { getPlatformType } from './platform';

// Product/conversion event tracking for authenticated users. Fire-and-forget —
// never blocks or breaks the UI. The backend attaches userId from the JWT and
// ignores any event not on its allowlist. Mirrors onboardingTracking.ts.

let cachedPlatform: string | undefined;
function platform(): string {
  if (!cachedPlatform) {
    try { cachedPlatform = getPlatformType(); } catch { cachedPlatform = 'web'; }
  }
  return cachedPlatform;
}

export function track(event: string, meta?: Record<string, any>): void {
  try {
    const token = localStorage.getItem('token');
    fetch(`${API_BASE_URL}/events`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ event, meta, platform: platform() }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* tracking must never break the app */
  }
}
